/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentPageResponse } from '../../models/content-page-response';

export interface GetApiPublicContentPageList$Params {

/**
 * 2 lower case letter locale
 */
  '_locale': 'de' | 'en' | 'fr';
}

export function getApiPublicContentPageList(http: HttpClient, rootUrl: string, params: GetApiPublicContentPageList$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentPageResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiPublicContentPageList.PATH, 'get');
  if (params) {
    rb.path('_locale', params['_locale'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentPageResponse>;
    })
  );
}

getApiPublicContentPageList.PATH = '/api/public/{_locale}/content-pages';
